/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SalesbyCategoryListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: SalesbyCategoryService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, HostBinding, EventEmitter, Input, Output, OnInit, ViewChild,
	trigger, transition, animate,
	style, state } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager }  from 'ng2-toastr';
import myGlobals = require('../globals');

import { SalesbyCategoryData, SalesbyCategoryService } from './SalesbyCategory.service';
import { SalesbyCategorySearchComponent }  from './SalesbyCategorySearch.component';

@Component({
	selector: 'my-SalesbyCategory',
	template: require('./SalesbyCategoryList.component.html'),
	providers: [SalesbyCategoryService],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.4s ease-in')
      ]),
      transition(':leave', [
        animate('0.7s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class SalesbyCategoryListComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}
	
	SalesbyCategoryList: SalesbyCategoryData[];
	newSalesbyCategory: SalesbyCategoryData;
	selectedSalesbyCategory: SalesbyCategoryData;
	errorMessage: string;
	messages: string[];
	showAdd: boolean;
	@ViewChild(SalesbyCategorySearchComponent) filterComponent: SalesbyCategorySearchComponent;

	sortExpression: string = "CategoryID";
	filterExpression: string = "";
	pageIndex: number = 1;
	pageSize: number = 10;
	endRowIndex: number;
	rowsCount: number;
	pageCount: number;
	isFirstPage: boolean;

    private selectedId: string;

	constructor(
		private SalesbyCategoryService: SalesbyCategoryService,
		private route: ActivatedRoute,
		private router: Router,
		private toastr: ToastsManager
	) {
		this.newSalesbyCategory = new SalesbyCategoryData();
		this.pageSize = myGlobals.pageSize;
	}

	ngOnInit() {
		// this.SalesbyCategoryService.getAll().subscribe(record => this.SalesbyCategoryList=record);
		this.pageIndex = 1;
		this.isFirstPage = true;
		this.getSalesbyCategoryByPaging();

		/*
		this.SalesbyCategoryList = this.route.params
			.switchMap((params: Params) => {
				this.selectedId = +params['id'];
				return this.service.getAll();
			});
		*/
	}

	// Get all records
	public getSalesbyCategory() {
		this.SalesbyCategoryService.getAll()
			.subscribe(data => this.SalesbyCategoryList = data,
		error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error);
	}
	
	// On Search CLick on SalesbyCategorySearch Component
	onSearch(searchText: string) {
		// 1. Update this.filterExpression
		this.filterExpression = searchText;

		// 2. call getSalesbyCategoryByPaging method that will refresh the data
		this.pageIndex = 1;
		this.getSalesbyCategoryByPaging();
	}
	
	onSort(event, sortColumn: string)
	{
		// var target = event.target || event.srcElement || event.currentTarget;
		// var parent = target.parentNode;
		if (this.sortExpression === sortColumn)
			this.sortExpression = sortColumn + ' desc';
		else if (this.sortExpression === sortColumn + ' desc')
			this.sortExpression = sortColumn;
		else
			this.sortExpression = sortColumn;
		this.getSalesbyCategoryByPaging();
	}
	
	// Get records by paging
	getSalesbyCategoryByPaging() {
		this.SalesbyCategoryService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
			.subscribe(data => {
				this.SalesbyCategoryList=data.SalesbyCategoryList;
				this.rowsCount=data.RowsCount; 
				this.pageCount= Math.ceil(this.rowsCount / this.pageSize);
				if (this.pageIndex == 1)
					this.isFirstPage = true;
				else
					this.isFirstPage = false;
				if (this.pageIndex == this.pageCount)
					this.endRowIndex = this.rowsCount;
				else
					this.endRowIndex = this.pageIndex * this.pageSize;
			},
			error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error
		);
	}
	// Adds new record
	addSalesbyCategory() {
		this.SalesbyCategoryService.addSalesbyCategoryData(this.newSalesbyCategory).subscribe(record => console.log(record));
		this.getSalesbyCategory();
	}
  
	// Updates existing record
	updateSalesbyCategory() {
		this.SalesbyCategoryService.updateSalesbyCategoryData(this.selectedSalesbyCategory).subscribe(record => console.log(record));
		this.getSalesbyCategory();
	}

	// Deletes record with specified id
	deleteSalesbyCategory(id: string) {
		if (window.confirm('Are you sure you want to delete this SalesbyCategory?') == true)
		{
			this.SalesbyCategoryService.deleteSalesbyCategory(id)
			.subscribe(data => this.getSalesbyCategory(), 
			error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error);
		}
	}

	// Go to First Page
	onFirstPage() {
		this.pageIndex = 1;
		this.getSalesbyCategoryByPaging();
	}

	// Go to Previous Page
	onPreviousPage() {
		if (this.pageIndex > 1) {
			this.pageIndex = this.pageIndex - 1;
			this.getSalesbyCategoryByPaging();
		}
	}

	// Go to Next Page
	onNextPage() {
		if (this.pageIndex < this.pageCount) {
			this.pageIndex = this.pageIndex + 1;
			this.getSalesbyCategoryByPaging();
		}
	}

	// Go to Last Page
	onLastPage() {
		this.pageIndex = this.pageCount;
		this.getSalesbyCategoryByPaging();
	}

	// Refresh - Go to First Page
	onRefresh() {
		this.onFirstPage();
	}

	// On Edit - Go to Edit page
	onSelect(item: SalesbyCategoryData) {
		this.router.navigate(['/SalesbyCategory', item.CategoryID]);
	}

	// On Details - Go to Details page
	onSelectDetails(item: SalesbyCategoryData) {
		this.router.navigate(['/SalesbyCategory/Details', item.CategoryID]);
	}

	// Set record as selected
	SelectSalesbyCategory(item: SalesbyCategoryData) {
		this.selectedSalesbyCategory = item;
	}

	// Submits form
	submitForm(data: Object) {
		console.log(data);
	}

	// Logs message onto Console
	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}

/*
	isSelected(item: SalesbyCategoryData) {
		return item.CategoryID === this.selectedId;
	}
*/
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/SalesbyCategory/SalesbyCategoryList.component.ts